import { Row, Col, Form, Input, InputNumber } from "antd";
import ImageUploadField from "components/fields/ImageUploadField";
import DatePickerField from "components/fields/DatePickerField";
import { useIntl } from "react-intl";
import TimezonePickerField from "components/fields/TimezonePickerField";
import { useMatch } from "react-router-dom";
import { ROUTE_PATHS } from "const/paths";
import { validateHtmlHeight } from "utils/htmlHeightValidator";
import useFormFieldMeta from "hooks/useFormFieldMeta";
import { namePathOrMatcher } from "utils/formUtils";

import EventDescriptionField from "./EventDescriptionField";
import SeatMapField from "./SeatMapField";
import PresalePasswordsField from "./PresalePasswordsField";

const EventInfo: React.FC = () => {
  const intl = useIntl();
  const isEditRoute = !!useMatch(ROUTE_PATHS.EventEdit);

  const { errors } = useFormFieldMeta(
    namePathOrMatcher({ equals: [["input", "ticketDescription"]] })
  );

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Event Name",
          })}
          name={["input", "name"]}
          required
        >
          <Input disabled={isEditRoute ? false : undefined} />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Description",
          })}
          name={["input", "description"]}
        >
          <EventDescriptionField disabled={isEditRoute ? false : undefined} />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "PDF Ticket Description",
          })}
          name={["input", "ticketDescription"]}
          rules={[validateHtmlHeight(220)]}
        >
          <EventDescriptionField
            disabled={isEditRoute ? false : undefined}
            placeholder={intl.formatMessage({
              defaultMessage: "PDF Ticket Description",
            })}
          />
        </Form.Item>
        {/* HACK - I don't know why this error is not rendered by antd */}
        {!!errors.length && (
          <>
            {errors.map((error) => (
              <p style={{ color: "#d4380d" }} key={error}>
                {error}
              </p>
            ))}
          </>
        )}
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Timezone",
          })}
          name={["input", "timezone"]}
          required
        >
          <TimezonePickerField autodetect />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Event Date",
          })}
          name={["input", "date"]}
          required
        >
          <DatePickerField
            disabled={isEditRoute ? false : undefined}
            utc
            showTime
          />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Door Time",
          })}
          extra={intl.formatMessage({
            defaultMessage: "Number of hours before event time.",
          })}
          name={["input", "doorTime"]}
          required
        >
          <InputNumber precision={0} min={0} />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Age limit",
          })}
          name={["input", "ageLimit"]}
          required
        >
          <InputNumber precision={0} min={0} />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Publish at",
          })}
          name={["input", "publishAt"]}
          required
        >
          <DatePickerField
            disabled={isEditRoute ? false : undefined}
            utc
            showTime
          />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Send tickets at",
          })}
          name={["input", "sendTicketsAt"]}
        >
          <DatePickerField utc showTime />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "YouTube URL",
          })}
          name={["input", "youtubeUrl"]}
        >
          <Input disabled={isEditRoute ? false : undefined} />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Image",
          })}
          name={["input", "image"]}
        >
          <ImageUploadField disabled={isEditRoute ? false : undefined} />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Seating Chart",
          })}
          name={["input", "seatMap"]}
        >
          <SeatMapField />
        </Form.Item>
        <Form.Item
          label={intl.formatMessage({
            defaultMessage: "Presale Passwords",
          })}
          name={["input", "presalePasswords"]}
        >
          <PresalePasswordsField />
        </Form.Item>
      </Col>
    </Row>
  );
};

export default EventInfo;
